export default "__VITE_ASSET__0CeQ29qZ__"